module.exports = __webpack_public_path__ + "img/179984.45ff396b.png";